module.exports = __webpack_public_path__ + "static/media/modern-mallory.b30082a9.png";